import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Container, Card, Spinner, Alert, Button } from "react-bootstrap";
import { authFetch } from "../utils/authFetch";
import { toast } from "react-toastify";
import { RecipeForm } from "./Form";

export default function RecipeEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [doc, setDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const fetchDoc = async () => {
    setLoading(true);
    setErr("");
    try {
      const data = await authFetch(`/bxreteta/${id}`);
      setDoc(data);
    } catch (e) {
      setErr(String(e?.message || e));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDoc();
  }, [id]);

  const handleSubmit = async (payload) => {
    setBusy(true);
    try {
      await authFetch(`/bxreteta/${id}`, {
        method: "PUT",
        body: JSON.stringify(payload),
      });
      toast.success("Rețeta a fost actualizată cu succes!");
      fetchDoc();
    } catch (e) {
      toast.error(`Eroare la actualizare: ${e?.message || e}`);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Container className="py-3">
      {err && <Alert variant="danger">{err}</Alert>}

      {loading ? (
        <div className="py-5 text-center">
          <Spinner animation="border" />
        </div>
      ) : (
        <Card className="shadow-sm">
          <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center">
            <h4 className="mb-0">Editează Rețetă: {doc?.cod_reteta || `#${doc?.id}`}</h4>
            <div className="d-flex gap-2">
            <Button as={Link} variant="outline-light" size="sm" to={`/retete/new?copy_from=${id}`}>Copiază rețeta</Button>
            <Button variant="light" size="sm" onClick={() => navigate("/retete")}>
              Înapoi la Listă
            </Button>
            </div>
          </Card.Header>
          <Card.Body>
            <RecipeForm
              initialDoc={doc}
              onSubmit={handleSubmit}
              busy={busy}
              onRefresh={fetchDoc}
            />
          </Card.Body>
        </Card>
      )}
    </Container>
  );
}
